import React, { useEffect } from 'react';
import { FiFileText, FiUserCheck, FiCreditCard, FiAlertCircle, FiXCircle } from 'react-icons/fi';
import Navbar from '../components/home/Navbar';
import Footer from '../components/home/Footer';

export default function Terms() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar />

            <main className="flex-grow pt-32 pb-20 px-4">
                <div className="max-w-4xl mx-auto">
                    {/* Header */}
                    <div className="text-center mb-12">
                        <div className="inline-flex items-center justify-center p-4 bg-indigo-100 text-indigo-600 rounded-2xl mb-4">
                            <FiFileText size={32} />
                        </div>
                        <h1 className="text-4xl font-bold text-gray-900 mb-4 poppins">Terms of Service</h1>
                        <p className="text-gray-600 font-medium poppins">Last updated: January 1, 2026</p>
                    </div>

                    {/* Content */}
                    <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10 poppins">
                        <section>
                            <div className="flex items-center gap-3 mb-4 text-indigo-600">
                                <FiUserCheck size={20} />
                                <h2 className="text-xl font-bold">User Accounts</h2>
                            </div>
                            <div className="text-gray-600 leading-relaxed space-y-4 font-regular">
                                <p>
                                    To access our classes and materials, you must register for an account. You agree to:
                                </p>
                                <ul className="list-disc pl-6 space-y-2 font-medium">
                                    <li>Provide accurate and complete information during registration.</li>
                                    <li>Keep your login credentials secure and confidential.</li>
                                    <li>Be responsible for all activities that occur under your account.</li>
                                    <li>Notify us immediately of any unauthorized use of your account.</li>
                                </ul>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-center gap-3 mb-4 text-indigo-600">
                                <FiCreditCard size={20} />
                                <h2 className="text-xl font-bold">Payment & Enrollment</h2>
                            </div>
                            <div className="text-gray-600 leading-relaxed font-regular">
                                <p className="mb-4">
                                    Access to specific months and class materials is granted upon successful verification of payment slips.
                                </p>
                                <ul className="list-disc pl-6 space-y-2 font-medium">
                                    <li>Payments must be made for each month as specified in the class details.</li>
                                    <li>Payment verification typically takes 24-48 hours.</li>
                                    <li>Once a payment is approved, it is non-refundable as access to digital content is granted immediately.</li>
                                    <li>In case of a rejected payment, you will be notified of the reason and may resubmit.</li>
                                </ul>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-center gap-3 mb-4 text-indigo-600">
                                <FiAlertCircle size={20} />
                                <h2 className="text-xl font-bold">Prohibited Conduct</h2>
                            </div>
                            <div className="text-gray-600 leading-relaxed font-regular">
                                <p className="mb-2">Users are strictly prohibited from:</p>
                                <ul className="list-disc pl-6 space-y-2 font-medium">
                                    <li>Sharing account access with others.</li>
                                    <li>Downloading, recording, or redistributing course content without permission.</li>
                                    <li>Using the portal for any illegal or unauthorized purpose.</li>
                                    <li>Attempting to interfere with the proper functioning of the portal.</li>
                                </ul>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-center gap-3 mb-4 text-indigo-600">
                                <FiXCircle size={20} />
                                <h2 className="text-xl font-bold">Termination</h2>
                            </div>
                            <p className="text-gray-600 leading-relaxed font-regular">
                                We reserve the right to suspend or terminate your account and access to the services at our sole discretion, without notice, for conduct that we believe violates these Terms of Service or is harmful to other users of the portal or us.
                            </p>
                        </section>

                        <div className="pt-8 border-t border-gray-100">
                            <p className="text-sm text-gray-400 italic text-center">
                                By using the Sudesh Maths Portal, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
                            </p>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
